import { reset, setUserId } from "@amplitude/unified";
import {
  clearMemberManagementToken,
  getFirebaseAuth,
} from "@risalabs_frontend_org/auth-wrapper";
import { signOut } from "firebase/auth";
import { clearBearerToken } from "../../../api/postCall/bearerToken";
import { UserStore } from "../../../store/UserGeneralInfoStore";
import { logError } from "../../../utils/customLogger";
import { AppDispatch } from "../../store/store";
import { logOutError } from "../auth-slice";
import { resetAllAppStates } from "./resetAllStateThunk";

/**
 * Signs out the current user from the shared auth-wrapper Firebase auth instance.
 *
 * @returns A thunk that clears auth/session state and app caches
 */
export const logOutUserFromFirebase = () => async (dispatch: AppDispatch) => {
  let unsubscribeAuthStateChanged: (() => void) | null = null;
  try {
    if (unsubscribeAuthStateChanged) {
      unsubscribeAuthStateChanged = null;
    }

    setUserId(undefined);
    reset();
    clearBearerToken();

    clearMemberManagementToken();

    const firebaseAuth = getFirebaseAuth();
    await signOut(firebaseAuth);
    clearDataFromStorage();
    dispatch(resetAllAppStates());
  } catch (error) {
    logError(error as Error, "Error during sign out");
    if (error instanceof Error) {
      dispatch(logOutError(error.message));
    } else {
      const errorMessage = "An unknown error occurred during logout.";
      dispatch(logOutError(errorMessage));
    }
  }
};

export const clearDataFromStorage = () => {
  try {
    localStorage.clear();
    UserStore.clearAll();
    sessionStorage.clear();
  } catch (error) {
    logError(error as Error, "Error clearing localStorage and sessionStorage");
  }
};
